import moment from "moment";

const defaultState = moment().toISOString();

const date = (state = defaultState, action) => {
  switch (action.type) {
    case "UPDATE_DATE":
      return action.payload;
    default:
      return state;
  }
};

export default date;



// WEBPACK FOOTER //
// ./src/reducers/dateReducer.js